import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
  selector: 'app-availability-navbar',
  templateUrl: './availability-navbar.component.html',
  styleUrls: ['./availability-navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AvailabilityNavbarComponent {
  // Component logic goes here
}
